module.exports = __webpack_public_path__ + "img/video-daka.9200dc63.png";